import type { PermissionRequirement } from '@/types/permission'

export function canAccessPermissionRequirement(
  requirement: PermissionRequirement | undefined,
  permissions: string[],
  _isAdmin = false
): boolean {
  if (!requirement) return true

  const has = (code: string) => permissions.includes(code)

  if (typeof requirement === 'string') {
    return has(requirement)
  }

  if (Array.isArray(requirement)) {
    return requirement.length === 0 || requirement.some(has)
  }

  const any = requirement.any ?? []
  const all = requirement.all ?? []
  const anyPassed = any.length === 0 || any.some(has)
  const allPassed = all.length === 0 || all.every(has)
  return anyPassed && allPassed
}
